
(() => {
  const pairs = {
    "53974966239592": "53973643854184", // Rose Quartz
    "53974966305128": "53973643886952", // Cream
    "53974966370664": "53973643919720"  // Black 2.0
  };

  const root = window.Shopify?.routes?.root || "/";
  const url = path => root + path;
  const giftIds = new Set(Object.values(pairs));

  let running = false;
  let queued = false;

  async function request(path, body) {
    const response = await fetch(url(path), {
      method: body ? "POST" : "GET",
      headers: body ? { "Content-Type": "application/json" } : {},
      body: body ? JSON.stringify(body) : undefined
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function syncGifts() {
    if (running) {
      queued = true;
      return;
    }

    running = true;
    let changed = false;

    try {
      const cart = await request("cart.js");

      for (const [quencherId, giftId] of Object.entries(pairs)) {
        const qualifyingQuantity = cart.items
          .filter(item => String(item.variant_id) === quencherId)
          .reduce((total, item) => total + item.quantity, 0);

        // One free gift per qualifying Quencher.
        const desired = qualifyingQuantity;

        const giftLines = cart.items.filter(item =>
          String(item.variant_id) === giftId &&
          item.properties?._stanley_promo_gift === "yes"
        );

        const current = giftLines.reduce(
          (total, item) => total + item.quantity, 0
        );

        if (current < desired) {
          await request("cart/add.js", {
            items: [{
              id: Number(giftId),
              quantity: desired - current,
              properties: {
                _stanley_promo_gift: "yes"
              }
            }]
          });
          changed = true;
        } else if (current > desired) {
          let excess = current - desired;

          for (const line of giftLines) {
            if (!excess) break;

            const reduction = Math.min(excess, line.quantity);

            await request("cart/change.js", {
              id: line.key,
              quantity: line.quantity - reduction
            });

            excess -= reduction;
            changed = true;
          }
        }
      }

      if (changed) {
        // Reload so Impulse and Shopify display the same cart.
        window.location.reload();
      }
    } catch (error) {
      console.error("Stanley free gift promotion:", error);
    } finally {
      running = false;

      if (queued && !changed) {
        queued = false;
        syncGifts();
      }
    }
  }

  // Impulse cart events.
  document.addEventListener("ajaxProduct:added", syncGifts);
  document.addEventListener("cart:updated", syncGifts);

  // Also check carts restored from previous visits.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncGifts);
  } else {
    syncGifts();
  }
})();
